import { render, staticRenderFns } from "./StepNav.vue?vue&type=template&id=12a19ff2"
import script from "./StepNav.vue?vue&type=script&lang=js"
export * from "./StepNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports